// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShakeOutlinedSvg from "@fishx/icons-svg/es/asn/ShakeOutlined";
import FishxIcon from '../components/FishxIcon';

var ShakeOutlined = function ShakeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShakeOutlinedSvg
  }));
};

ShakeOutlined.displayName = 'ShakeOutlined';
export default React.forwardRef(ShakeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShakeOutlined.js
// module id = 4096
// module chunks = 0